var _path, _g, _path2, _g2, _path3, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIlustraEnviar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 299 299",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_103_5040",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 299,
    height: 299
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0L299 0L299 299L0 299L0 0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_103_5040)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M264.205 149.5C264.205 212.73 212.948 263.989 149.716 263.989C86.4867 263.989 35.2285 212.73 35.2285 149.5C35.2285 86.2692 86.4867 35.011 149.716 35.011C212.948 35.011 264.205 86.2692 264.205 149.5Z",
    fill: "#FFF8C6"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_103_5040",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 35,
    width: 230,
    height: 229
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.2285 149.5C35.2285 212.731 86.4867 263.989 149.716 263.989C212.948 263.989 264.205 212.731 264.205 149.5C264.205 86.2692 212.948 35.0121 149.716 35.0121C86.4867 35.0121 35.2285 86.2692 35.2285 149.5Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_103_5040)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M289.712 149.91C289.712 218.988 227.204 274.988 150.094 274.988C72.9853 274.988 10.4766 218.988 10.4766 149.91C10.4766 80.8316 72.9853 24.8321 150.094 24.8321C227.204 24.8321 289.712 80.8316 289.712 149.91Z",
    fill: "#E0EEE0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_103_5040",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 299,
    height: 299
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0L299 0L299 299L0 299L0 0Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_103_5040)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.2182 244.057L61.8618 245.639L60.6981 246.997L59.3417 248.578C58.5926 249.452 58.6936 250.767 59.5677 251.516C60.4408 252.265 61.7566 252.164 62.5056 251.29L63.8621 249.71L65.0258 248.351L66.3822 246.77C67.1302 245.895 67.0302 244.58 66.1561 243.831C65.2821 243.081 63.9673 243.183 63.2182 244.057Z",
    fill: "#93BF8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0806 253.548L54.4024 254.339L55.2733 253.324L54.5951 254.115C53.845 254.989 53.9471 256.305 54.8201 257.053C55.6942 257.802 57.01 257.701 57.758 256.827L58.4363 256.037L57.5664 257.051L58.2446 256.261C58.9936 255.387 58.8926 254.071 58.0185 253.322C57.1444 252.573 55.8297 252.674 55.0806 253.548Z",
    fill: "#93BF8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3751 210.046L91.0187 211.628L69.5125 236.714L68.1561 238.296C67.407 239.17 67.5081 240.486 68.3822 241.235C69.2552 241.983 70.571 241.883 71.3201 241.009L72.6755 239.426L94.1827 214.34L95.5391 212.759C96.2882 211.886 96.1871 210.57 95.313 209.821C94.4389 209.071 93.1242 209.173 92.3751 210.046Z",
    fill: "#93BF8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.06 204.38L57.7036 205.963L56.5399 207.319L55.1835 208.902C54.4344 209.776 54.5354 211.09 55.4095 211.839C56.2826 212.589 57.5984 212.488 58.3474 211.613L59.7039 210.032L60.8676 208.674L62.224 207.093C62.972 206.219 62.872 204.903 61.9979 204.154C61.1239 203.405 59.8091 203.506 59.06 204.38Z",
    fill: "#93BF8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2449 214.662L49.0801 216.021C48.3321 216.894 48.4332 218.208 49.3062 218.958C50.1803 219.708 51.4951 219.605 52.2441 218.732L53.4089 217.375C54.1569 216.501 54.0569 215.185 53.1828 214.436C52.3087 213.687 50.9939 213.788 50.2449 214.662Z",
    fill: "#93BF8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7857 223.363L41.622 224.72C40.873 225.594 40.974 226.909 41.8471 227.658C42.7211 228.407 44.0369 228.306 44.785 227.432L45.9497 226.076C46.6988 225.202 46.5977 223.886 45.7236 223.137C44.8496 222.388 43.5348 222.489 42.7857 223.363Z",
    fill: "#93BF8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.1837 172.742L84.8272 174.325L65.3547 197.037L63.9993 198.62C63.2503 199.493 63.3503 200.808 64.2244 201.558C65.0984 202.307 66.4132 202.205 67.1623 201.332L68.5187 199.75L87.9912 177.037L89.3476 175.455C90.0957 174.582 89.9957 173.266 89.1216 172.517C88.2475 171.767 86.9327 171.869 86.1837 172.742Z",
    fill: "#93BF8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.663 237.622L142.307 239.204L141.143 240.561L139.787 242.143C139.039 243.017 139.139 244.332 140.013 245.081C140.886 245.83 142.201 245.729 142.951 244.855L144.307 243.273L145.471 241.916L146.827 240.334C147.576 239.46 147.475 238.145 146.601 237.396C145.728 236.646 144.412 236.747 143.663 237.622Z",
    fill: "#93BF8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.17 248.695L132.814 250.277L131.65 251.634L130.294 253.217C129.545 254.091 129.646 255.405 130.52 256.154C131.393 256.903 132.709 256.802 133.458 255.928L134.813 254.347L135.978 252.988L137.334 251.408C138.082 250.534 137.982 249.218 137.108 248.469C136.234 247.72 134.919 247.821 134.17 248.695Z",
    fill: "#93BF8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.355 258.977L123.999 260.559L125.547 258.753L124.19 260.335C123.442 261.208 123.544 262.523 124.417 263.272C125.291 264.022 126.605 263.92 127.354 263.047L128.711 261.466L127.163 263.271L128.519 261.69C129.267 260.815 129.167 259.5 128.293 258.751C127.419 258.002 126.104 258.103 125.355 258.977Z",
    fill: "#93BF8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.616 217.849L159.259 219.43L151.314 228.697L149.959 230.28C149.21 231.154 149.311 232.468 150.184 233.217C151.058 233.966 152.374 233.865 153.123 232.991L154.478 231.41L162.423 222.142L163.78 220.561C164.529 219.687 164.428 218.372 163.554 217.623C162.681 216.873 161.366 216.975 160.616 217.849Z",
    fill: "#93BF8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.826 48.9356L145.657 163.221L137.405 175.134V215.135L171.483 181.741L152.125 157.055",
    fill: "#F4C76D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.452 166.582L51.3291 148.799L226.29 45.3412L226.29 202.328L138.81 175.563",
    fill: "#F8E094"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.406 215.135L110.988 167.053L224.826 48.9361L137.863 175.185L137.406 215.135Z",
    fill: "#F3B854"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.5078 94.201C41.5078 99.7299 46.0043 104.226 51.5332 104.226C57.0621 104.226 61.5585 99.7299 61.5585 94.201C61.5585 88.6721 57.0621 84.1756 51.5332 84.1756C46.0043 84.1756 41.5078 88.6721 41.5078 94.201ZM44.6333 94.201C44.6333 90.3963 47.7285 87.3011 51.5332 87.3011C55.3379 87.3011 58.4331 90.3963 58.4331 94.201C58.4331 98.0057 55.3379 101.101 51.5332 101.101C47.7285 101.101 44.6333 98.0057 44.6333 94.201Z",
    fill: "#93BF8B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.676 210.796C197.676 213.454 199.838 215.615 202.495 215.615C205.154 215.615 207.316 213.454 207.316 210.796C207.316 208.137 205.154 205.976 202.495 205.976C199.838 205.976 197.676 208.137 197.676 210.796ZM198.718 210.796C198.718 208.712 200.413 207.017 202.495 207.017C204.579 207.017 206.274 208.712 206.274 210.796C206.274 212.879 204.579 214.574 202.495 214.574C200.413 214.574 198.718 212.879 198.718 210.796Z",
    fill: "#93BF8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.997 253.938C233.997 254.909 233.21 255.695 232.24 255.695C231.27 255.695 230.482 254.909 230.482 253.938C230.482 252.967 231.27 252.18 232.24 252.18C233.21 252.18 233.997 252.967 233.997 253.938Z",
    fill: "#93BF8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0464 171.108C61.0464 174.09 58.6294 176.508 55.6477 176.508C52.666 176.508 50.249 174.09 50.249 171.108C50.249 168.127 52.666 165.71 55.6477 165.71C58.6294 165.71 61.0464 168.127 61.0464 171.108Z",
    fill: "#93BF8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.089 233.101C108.089 234.072 107.303 234.859 106.332 234.859C105.361 234.859 104.574 234.072 104.574 233.101C104.574 232.13 105.361 231.344 106.332 231.344C107.303 231.344 108.089 232.13 108.089 233.101Z",
    fill: "#93BF8B"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIlustraEnviar);
export default __webpack_public_path__ + "static/media/ilustra-enviar.193fb487955b592f868d9f0eefc8a867.svg";
export { ForwardRef as ReactComponent };